


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import AmeldingForm from './AmeldingForm.vue';
import AmeldingContact from './AmeldingContact.vue';
import range from 'lodash/range';
import permissionGuard from '@/guards/permission-guard';
import dayjs from '@/utils/dayjs';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_getAmelding } from '@/queries/__generated__/getAmelding';
import { GQL_getAmeldingResendData_amelding } from '@/queries/__generated__/getAmeldingResendData';
import gql from 'graphql-tag';

const GET_AMELDING_RESEND_DATA = gql`
  query getAmeldingResendData($id: ID!) {
    amelding(id: $id) {
      id
      ameldingReference
      calendarMonth
      paychecks { id }
      ameldingPensionAmounts {
        amount
        subUnit { id }
        employerTaxZone { id }
      }
      ameldingReimbursements {
        amount
        subUnit { id }
        employerTaxZone { id }
      }
      ameldingWorkRelations {
        workRelation { id }
        subUnit { id }
        startDate
        endDate
        endReason
        occupation { id name }
        samePositionSince
        shiftType
        employee { id }
        employmentType
        employmentPercentage
        employmentPercentageUpdated
        hoursEveryWeekWithFullEmployment
        lastSalaryChange
        durationType
      }
    }
  }
`;

@Component({
  components: {
    AmeldingForm,
    AmeldingContact,
  },
  beforeRouteEnter: (to, from, next) => {
    permissionGuard('canSendAltinnPaycheckReports', to, from, next)
      .catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class AmeldingsNew extends Vue {
  @Prop({ type: [ Number, String ], default: dayjs().year() }) public year!: number | string;
  @Prop({ type: [ Number, String ] }) public ameldingToReplaceId?: number | string;

  @SmartQuery<AmeldingsNew, GQL_getAmelding>({
    skip() { return !this.ameldingToReplaceId },
    query: GET_AMELDING_RESEND_DATA,
    fetchPolicy: 'no-cache',
    variables() {
      return { id: this.ameldingToReplaceId };
    },
    update: (data) => data.amelding,
    result(data) {
      this.selectedCalendarMonth = data.data.amelding!.calendarMonth!;
    },
  }) private ameldingToReplace!: GQL_getAmeldingResendData_amelding;

  private selectedCalendarMonth: string | null = null;

  private get calendarMonthsForSelectedYear(): string[] {
    return range(1, 13).map(month => `${this.year}-${String(month).padStart(2, '0')}`);
  }

  private reportSent(): void {
    this.$router.push({ name: 'Ameldings' });
    this.$sMessage.success(this.$t('Message.saveSuccess'));
  }
}
